import type { JSX } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './select.styles';
export interface SelectOption {
  value: string;
  label: string;
  /** Shown but not choosable — for an option that exists and does not apply
   *  right now, where hiding it would leave the reader wondering where it went. */
  disabled?: boolean;
}
interface SelectProps extends Omit<JSX.IntrinsicElements['select'], 'ref'> {
  options: SelectOption[];
  /** Marks the field invalid: danger border + danger focus ring + aria-invalid. */
  invalid?: boolean;
}
export function Select({
  options,
  invalid = false,
  ...rest
}: SelectProps) {
  return <select {...rest} aria-invalid={invalid || undefined} {...stylex.props(styles.select, invalid && styles.invalid)}>
      {options.map(o => <option key={o.value} value={o.value} disabled={o.disabled}>
          {o.label}
        </option>)}
    </select>;
}